import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Grid, Layout } from 'antd';
import Chatbot from '@/components/Chat';
import { EnvironmentAlert } from '@/components/EnvironmentAlert';
import env from '@/env';
import { useAuth } from '../../contexts/Auth';
import { useMenu } from '../../contexts/Menu';
import { SideBar, TopBar } from '../../components/Layout';

const { Content } = Layout;

const PrivateRoute: React.FC<any> = ({ role }) => {
    const { isAuth, data } = useAuth();
    const location = useLocation();

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.xl;

    const { isCollapsed, setCollapsed } = useMenu();

    if (!isAuth) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (role && role.length > 0 && data.role?.length > 0) {
        const hasPermission = data.role?.some((userRole: { type: string }) =>
            role.includes(userRole?.type),
        );

        if (!hasPermission) {
            return <Navigate to="/" replace />;
        }
    }

    return (
        <Layout hasSider>
            {env.API_URL?.includes('staging') && <EnvironmentAlert />}

            {isMobile && !isCollapsed && (
                <button
                    type="button"
                    tabIndex={-1}
                    aria-hidden="true"
                    onClick={() => setCollapsed(true)}
                    style={{
                        position: 'fixed',
                        inset: 0,
                        border: 'none',
                        margin: 0,
                        padding: 0,
                        background: 'transparent',
                        zIndex: 1100,
                        cursor: 'pointer',
                    }}
                />
            )}

            <SideBar />

            <Layout>
                <TopBar />
                <Content
                    style={{
                        overflow: 'hidden',
                        margin: `${isMobile ? '70px' : '24px'} ${
                            isMobile ? '12px' : '16px'
                        } ${isMobile ? '60px' : '50px'}`,
                    }}
                >
                    <Outlet />
                    <Chatbot />
                </Content>
            </Layout>
        </Layout>
    );
};

export default PrivateRoute;
